<template>
    <div id="Busqueda_div">
        <h6 class="label-black">Búsqueda Documento</h6>
        <hr />
        <div class="form-group" id="AreasCatalogo" v-if="Usuario.Area.AreaId==21" >
            <label class="label-black" >Área</label>
            <CAreas
            v-on:valorParaElPadre="cambioDeArea" 
            :prefijo="enumeraciones.etiquetasDeHTML.Select" 
            :tipo="enumeraciones.tiposDeSelect.Seleccione" 
            :idDelInput="'catalogoAreas'" 
            :parametros="BusquedaForm.parametros_Area" 
            :valorDefinido="BusquedaForm.parametros_Area.areaId" 
            :key="BusquedaForm.parametros_Area.areaId"
            >
            </CAreas>
        </div>
        <div class="form-group" id="inputArea" v-else>
            <label class="label-black">Área</label>
            <input class="form-control" type="text" v-model="Usuario.Area.Nombre" readonly />
        </div>
        <div class="form-group" id="inputMateriaPenal" v-if="BusquedaForm.parametros_Area.areaId==17 || BusquedaForm.parametros_Area.areaId==18 || BusquedaForm.parametros_Area.areaId==24 || BusquedaForm.parametros_Area.areaId==27 || BusquedaForm.parametros_Area.areaId==29">
            <label class="label-black">Materia Penal : &nbsp; </label>
            <input type="checkbox" v-model="chkPenalMajat" id="checkMajat" />
        </div>
        <div class="form-group" id="BusquedaDoc_div" v-if="BusquedaForm.parametros_Area.areaId!=undefined && BusquedaForm.parametros_Area.areaId!=null && BusquedaForm.parametros_Area.areaId>0 && AreaValida==true">
            <label class="label-black">Tipo de Documento</label>
            <CTipoDocumento
            v-on:valorParaElPadre="cambioDocumento"
            :prefijo="enumeraciones.etiquetasDeHTML.Select" 
            :tipo="enumeraciones.tiposDeSelect.Seleccione" 
            :idDelInput="'catalogoDocumento'" 
            :parametros="BusquedaForm.parametros_TipoDocumento" 
            :valorDefinido="BusquedaForm.parametros_TipoDocumento.tipoDocumentoId"
            :key="BusquedaForm.parametros_TipoDocumento.tipoDocumentoId" 
            
        ></CTipoDocumento>
        </div>

        <!-- <div class="form-group" id="Anio_div" v-if="BusquedaForm.parametros_TipoDocumento.tipoDocumentoId!=undefined && BusquedaForm.parametros_TipoDocumento.tipoDocumentoId!=null && BusquedaForm.parametros_TipoDocumento.tipoDocumentoId>0">
            <label class="label-black">Año</label>
            <input class="form-control" type="number" placeholder="####" v-model="BusquedaForm.Anio" />
        </div> -->
        <div class="form-group" id="Consecutivo_div" v-if="BusquedaForm.parametros_TipoDocumento.tipoDocumentoId!=undefined && BusquedaForm.parametros_TipoDocumento.tipoDocumentoId!=null && BusquedaForm.parametros_TipoDocumento.tipoDocumentoId>0">
            <label class="label-black">Consecutivo</label>
            <input class="form-control" type="text" placeholder="####/####" v-model="BusquedaForm.Consecutivo" v-mask="'####/####'" v-on:keyup.enter= 'CargaDocumento()' @keyup="ObtenerAnio($event)" />
        </div>
        <div class="form-group" id="Numero_div" v-if="BusquedaForm.parametros_TipoDocumento.tipoDocumentoId ==2 || BusquedaForm.parametros_TipoDocumento.tipoDocumentoId == 10" >
            <label class="label-black">Numero de Elemento</label>
            <input class="form-control" type="number" placeholder="Numero" v-model="BusquedaForm.Numero" />
        </div>
        <div class="form-group" id="Sufijo_div" v-if="(BusquedaForm.parametros_Area.areaId==95 || BusquedaForm.parametros_Area.areaId==21 )&& (AnioEjecucion>1995 && AnioEjecucion<2021)">
            <label class="label-black">Sufijo</label>
            <input class="form-control" type="text" placeholder="Numero Romano" v-model="BusquedaForm.Sufijo" v-on:keyup= 'DetectarSufijo' />
        </div>
        <div class="form-group" id="Codigo_div">
            <label class="label-black">Código de Barras</label>
            <input class="form-control" type="text" placeholder="##############" v-model="BusquedaForm.CodigoBarras" v-on:keyup.enter= 'DetectarEnter' @change="LimpiarPorCodigo()"/>
        </div>
            
        <div id="BotonBusqueda_div" class="text-right">
        <button class="btn btn-sm btn-custom"  @click='CargaDocumento()'>Buscar Documento</button>
        </div>
    </div>
</template>

<script>
import enumeraciones from '@/../static/js/enumeraciones'
import api from '@/../static/js/api'
import comun from '@/../static/js/comun'
import axios from 'axios'
import catalogos from '@/../static/js/catalogos'
import VueMask from 'v-mask'

export default {
    components:{
      CAreas : catalogos.ArchivoJudicial.C001Areas,
      CTipoDocumento: catalogos.PJ.C004TipoDocumento
    }, 
    data(){
        return{
            enumeraciones,
            AnioEjecucion: 0,
            BusquedaForm: {
                    
                    Consecutivo: "",
                    Sufijo:"",
                    CodigoBarras: "",
                    parametros_Area: {
                        areaId: -1,
                        conMaterias: true,
                        conOrdenamientoPorSistema: true,
                        Materias: [ { MateriaId: 1, Activo: true },{ MateriaId: 2, Activo: true }, { MateriaId: 3, Activo: true }, { MateriaId: 4, Activo: true }, { MateriaId: 5, Activo: true } , { MateriaId: 6, Activo: true }, { MateriaId: 9, Activo: true }, { MateriaId: 13, Activo: true } ], 
                    },
                    parametros_TipoDocumento: {
                        tipoDocumentoId: -1,
                        areaId: -1,
                        materiaId: -1,
                        soloDocumentosPrincipales: true,
                        nombre:""
                    },
                    Numero: null
                    
                },
            Documento: {},
            SufijoPeticion:"",
            AreaValida: true,
            areaConsulta: -1,
            Usuario: {
                Area: {
                    AreaId:0,
                    Nombre:""
                }
            },
            ActualizarConsulta: false,
            chkPenalMajat:false
        }
    }, 
    props: {
        barCode: {
            type: String,
            default: ""
        },
        IncidenteCode:{
            type: String,
            default: ""
        },
        actualiza :false
        
    },
    methods:{
        obtenFechaConFormato: function(fechaRegistro) {
        return moment(fechaRegistro).format("DD-MM-YYYY <br /> h:mm a");
        },
        cambioDeArea(datos){
            this.BusquedaForm.parametros_Area.areaId = parseInt(datos[0].target.value);
            
            if(this.BusquedaForm.parametros_Area.areaId>0)
            {
                
                this.chkPenalMajat= false;
                
                this.BusquedaForm.parametros_TipoDocumento.areaId = datos[1].AreaId;
                if (datos[1].Materias != undefined && datos[1].Materias != null && datos[1].Materias.length>0 )
                {   
                    
                    this.AreaValida = true;
                    if(datos[1].Materias.length == 1)
                    {
                        this.BusquedaForm.parametros_TipoDocumento.materiaId = datos[1].Materias[0].MateriaId
                    }
                    else 
                    {
                        if(datos[1].AreaId!=27)
                        {
                            this.BusquedaForm.parametros_TipoDocumento.materiaId = datos[1].Materias[1].MateriaId
                        }
                        else
                        {
                            this.BusquedaForm.parametros_TipoDocumento.materiaId = datos[1].Materias[0].MateriaId
                        }
                        
                    }
                }
                else
                {
                    this.AreaValida = false;
                    comun.mensajeDeAlerta("No se encontraron Tipos de Documentos del área seleccionada.", null, null);
                }

            }
            else{
                this.BusquedaForm.parametros_TipoDocumento.tipoDocumentoId = -1;
                this.BusquedaForm.parametros_TipoDocumento.areaId = null;
                this.BusquedaForm.parametros_TipoDocumento.materiaId = null;
            }
            
            if(this.BusquedaForm.parametros_Area.areaId ==95)
            {
                comun.mensajeDeAlerta("Para la Consulta de Expedientes del Juzgado de Ejecución de Penas y Medidas de Seguridad anteriores al año 2021, debera completarse el Sufijo en Numero Romano de acuerdo a su procedencia:" 
                + "</br>I   .- Juzgado Primero de Ejecución."
                + "</br>II  .- Juzgado Segundo de Ejecución."
                + "</br>III .- Unidad de Gestión"
                + "</br>Por Codigo de Barras 42xxxXXXXxxxx + Sufijo.", null, null);
            };
           
        },
        cambioDocumento(datos){
            this.BusquedaForm.parametros_TipoDocumento.tipoDocumentoId = parseInt(datos.target.value);
            this.BusquedaForm.parametros_TipoDocumento.nombre = datos.target.selectedOptions[0].text;
        },
        CargaDocumento : function(){
            var area=0;
            var TipoDoc = 0;
            if(this.BusquedaForm.CodigoBarras!='' && this.BusquedaForm.CodigoBarras!=null && this.BusquedaForm.CodigoBarras!=undefined)
            {
                area = parseInt(this.BusquedaForm.CodigoBarras.substr(0,2));
                TipoDoc = parseInt(this.BusquedaForm.CodigoBarras.substr(2,3));
                if( (area==17 || area==18 || area==24 ||area==29) && TipoDoc == 9)
                {
                    this.chkPenalMajat=true
                }
                else
                {
                    this.chkPenalMajat = false;
                };
            };
            if (this.ValidaDatosBuqueda())                    
            {
                var consecutivoSubs =this.BusquedaForm.Consecutivo.substr(0,4)
                var anioSubs = this.BusquedaForm.Consecutivo.substr(5,4);
                var peticion={};
                if(this.Usuario.Area.AreaId ==21)
                {
                    peticion = {
                        "AreaId": this.BusquedaForm.parametros_Area.areaId,
                        "TipoDocumentoId" :this.BusquedaForm.parametros_TipoDocumento.tipoDocumentoId,
                        "Anio" : anioSubs,//this.BusquedaForm.Anio,
                        "Consecutivo": consecutivoSubs,//this.BusquedaForm.Consecutivo,
                        "Numero": this.BusquedaForm.Numero,
                        "Sufijo": this.BusquedaForm.Sufijo,
                        "CodigoBarras": this.BusquedaForm.CodigoBarras,
                        "chkPenalMajat": this.chkPenalMajat
                    };
                }
                else
                {   
                    var area_Peticion= -1;
                    if(this.BusquedaForm.CodigoBarras=="" || this.BusquedaForm.CodigoBarras==null)
                    {
                        area_Peticion = this.Usuario.Area.AreaId;
                    }
                    peticion = {
                        "AreaId": area_Peticion,
                        "TipoDocumentoId" :this.BusquedaForm.parametros_TipoDocumento.tipoDocumentoId,
                        "Anio" : anioSubs,//this.BusquedaForm.Anio,
                        "Consecutivo": consecutivoSubs,//this.BusquedaForm.Consecutivo,
                        "Numero": this.BusquedaForm.Numero,
                        "Sufijo": this.BusquedaForm.Sufijo,
                        "CodigoBarras": this.BusquedaForm.CodigoBarras,
                        "chkPenalMajat": this.chkPenalMajat
                    };
                }
                comun.SeEstaCargandoInformacion(true);
                axios.post(api.conexion + api.ArchivoJudicial.ObtenerDocumento, peticion,
                comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal))
                .then( respuesta => {
                    if(respuesta.data.SiHayError)
                    {
                        comun.SeEstaCargandoInformacion(false);
                        console.log(respuesta);
                        comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
                        this.LimpiaParametrosBusqueda();
                    }
                    else
                    {   
                        this.LimpiaParametrosBusqueda();
                        comun.SeEstaCargandoInformacion(false);
                        var DocumentoObtenido =respuesta.data.GetDocumento;
                        var Listado = respuesta.data.Listado;
                        var InfoDoc = respuesta.data.InfoDocPrincipal;
                        var incidente = respuesta.data.InfoIncidente!=null ? respuesta.data.InfoIncidente : respuesta.data.IncidenteVolumen ;
                        var terceria = respuesta.data.InfoTercerias !=null ? respuesta.data.InfoTercerias: null;
                        var Usuario = respuesta.data.Usuario;
                        this.ActualizarConsulta = false;
                        this.Emitir(DocumentoObtenido, InfoDoc, incidente, terceria, Usuario, Listado);
                        if(respuesta.data.Satisfactorio!='Se ha cargado informacion del documento' && respuesta.data.Satisfactorio!=null)
                        {
                            comun.mensajeDeAlerta(respuesta.data.Satisfactorio, null, null);
                        }
                        
                    }
                    comun.SeEstaCargandoInformacion(false);
                    
                })
                .catch(excepcion => {
                    console.log(excepcion);
                    console.log("fallo por parametros");
                    comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null);
                    comun.SeEstaCargandoInformacion(false);
                })
            }
        },
        LimpiaParametrosBusqueda() {
            if(this.Usuario.Area.AreaId == 21)
            {
                this.BusquedaForm.parametros_Area.areaId = -1;

                this.BusquedaForm.parametros_TipoDocumento.tipoDocumentoId= -1;
                this.AnioEjecucion =0;
                this.BusquedaForm.Consecutivo =null;
                this.BusquedaForm.Sufijo = "";
                this.BusquedaForm.CodigoBarras=null;
                this.SufijoPeticion="";
                this.BusquedaForm.Numero = null;
                this.chkPenalMajat = false;
            }
            if(this.Usuario.Area.AreaId != 21)
            {
                this.BusquedaForm.parametros_Area.areaId = this.Usuario.Area.AreaId;
                this.BusquedaForm.parametros_TipoDocumento.tipoDocumentoId= -1;
                this.AnioEjecucion =0;
                this.BusquedaForm.Consecutivo =null;
                this.BusquedaForm.Sufijo = "";
                this.BusquedaForm.CodigoBarras=null;
                this.SufijoPeticion="";
                this.BusquedaForm.Numero = null;
                this.chkPenalMajat = false;
            }
        },
        LimpiarPorCodigo(){
            if(this.Usuario.Area.AreaId == 21)
            {
                this.BusquedaForm.parametros_Area.areaId = -1;

                this.BusquedaForm.parametros_TipoDocumento.tipoDocumentoId= -1;
                this.BusquedaForm.Anio =null;
                this.BusquedaForm.Consecutivo =null;
                this.BusquedaForm.Sufijo = "";
                this.SufijoPeticion="";
                this.BusquedaForm.Numero = null;
            }
            if(this.Usuario.Area.AreaId != 21)
            {
                this.BusquedaForm.parametros_Area.areaId = this.Usuario.Area.AreaId;
                this.BusquedaForm.parametros_TipoDocumento.tipoDocumentoId= -1;
                this.BusquedaForm.Anio =null;
                this.BusquedaForm.Consecutivo =null;
                this.BusquedaForm.Sufijo = "";
                this.BusquedaForm.Numero = null;
                this.SufijoPeticion="";
            }
        },
        ValidaDatosBuqueda(){
            //aqui validamos los parametros de entrada para busqueda.
            if(this.BusquedaForm.CodigoBarras == "" || this.BusquedaForm.CodigoBarras == null)
            {
                if(this.BusquedaForm.parametros_Area == null || this.BusquedaForm.parametros_Area.areaId == -1)
                    { comun.mensajeDeAlerta("Indicar el área del Documento.", null, null);
                    return false;}
                if(this.BusquedaForm.parametros_TipoDocumento ==null || this.BusquedaForm.parametros_TipoDocumento.tipoDocumentoId == -1)
                    { comun.mensajeDeAlerta("Indicar el tipo del Documento.", null, null);
                    return false;}
                // if(this.BusquedaForm.Anio =="" ||this.BusquedaForm.Anio == null )
                //     {comun.mensajeDeAlerta("Complete el año del Documento.", null, null)
                //     return false;}
                // if(this.BusquedaForm.Anio.length != 4)
                //     {comun.mensajeDeAlerta("El formato del año debe contener 4 digitos.", null, null)
                //     return false;}
                if (this.BusquedaForm.Consecutivo =="" || this.BusquedaForm.Consecutivo == null)
                    {comun.mensajeDeAlerta("Complete el Consecutivo del Documento.", null, null)
                    return false;}
                if(this.BusquedaForm.parametros_TipoDocumento.tipoDocumentoId ==2 || this.BusquedaForm.parametros_TipoDocumento.tipoDocumentoId ==10)
                {
                    if(this.BusquedaForm.Numero<=0)
                    {
                        {comun.mensajeDeAlerta("Complete el Numero de "+ this.BusquedaForm.parametros_TipoDocumento.nombre + " para realizar la busqueda", null, null)
                        return false;}
                    }
                }
                if(this.BusquedaForm.Consecutivo.length != 9)
                    {comun.mensajeDeAlerta("El formato del consecutivo debe contener 8 digitos.", null, null)
                    return false;}
                if((this.BusquedaForm.Sufijo=="" || this.BusquedaForm.Sufijo==null) && this.AnioEjecucion<2021)
                {
                    if(this.BusquedaForm.parametros_Area.areaId == 95 || this.BusquedaForm.parametros_Area.areaId == 21)
                    {
                        comun.mensajeDeAlerta("Complete el Sufijo del Documento", null, null)
                        return false;
                    }
                }
                return true
            }
            else
            {
                this.BusquedaForm.parametros_Area.areaId=-1
                this.BusquedaForm.parametros_TipoDocumento.tipoDocumentoId=-1;
                this.BusquedaForm.Anio= '';
                this.BusquedaForm.Consecutivo='';
                var Resultado = this.ChecaCodigo(this.BusquedaForm.CodigoBarras);
                if(Resultado.Estatus!=true)
                {
                    comun.mensajeDeAlerta(Resultado.Mensaje, null, null);
                    this.BusquedaForm.CodigoBarras="";
                    return false;
                }
                return true;    
            }
            
        },
        Emitir(documento, info, incidente, terceria, user, Listado){
            this.$emit("ValorDeConsulta", {"DocumentoConsulta": documento, "DocumentoReferenciado" : info, "InfoIncidente": incidente , "InfoTerceria": terceria , "UserId": user, "Listado": Listado});
            
        },
        DetectarEnter: function(e){
            
            if (e.keyCode==13)
            {
                this.BusquedaForm.parametros_Area.areaId=-1
                this.BusquedaForm.parametros_TipoDocumento.tipoDocumentoId=-1;
                this.BusquedaForm.Anio= '';
                this.BusquedaForm.Consecutivo='';
                var Resultado = this.ChecaCodigo(this.BusquedaForm.CodigoBarras);
                if(Resultado.Estatus==true)
                {
                    this.CargaDocumento();
                }
                else
                {
                    comun.mensajeDeAlerta(Resultado.Mensaje, null, null);
                }
            }
        },
        DetectarSufijo: function(e){
            if (e.keyCode==16 || e.keyCode ==73)
            {
                this.SufijoPeticion += "I";
            }
            if (e.keyCode==8)
            {
                var conteo = this.SufijoPeticion.length;
                var cadena = this.SufijoPeticion.substr(1, conteo-1);
                this.SufijoPeticion = cadena;
            }
            this.BusquedaForm.Sufijo = this.SufijoPeticion;
        },
        ChecaCodigo: function(codigo){
            let _this=this;
            var Verificado= {
                Estatus: false,
                Mensaje: ""
            }
            if(this.Usuario.Area.AreaId==21)//Archivo
            {
                var area = parseInt(codigo.substr(0,2));
                var TipoDoc = parseInt(codigo.substr(2,3));
                switch(codigo.length) // Verifica la Longitud del Código de Barras y determinar caracteres
                {
                case 13:
                    var estado = !isNaN(parseFloat(codigo)) && isFinite(codigo);
                    var anio = parseInt(codigo.substr(5,4));
                    
                    if (area!=42)
                    {
                        if (estado==false)
                        {
                            Verificado.Estatus = false;
                            Verificado.Mensaje = "Verificar código, deben ser caracteres numéricos"
                        }
                        else
                        {
                            Verificado.Estatus = estado;
                            Verificado.Mensaje = ""
                        }
                    }
                    if (area==42)
                    {
                        if(anio<=2020)
                        {
                            Verificado.Estatus = false;
                            Verificado.Mensaje = "Verificar código de barras, para documento del 2020 o inferiores se requiere complementar con numero romano correspondiente al área a consultar"
                                                    + "</br>I   .- Juzgado Primero de Ejecución."
                                                    + "</br>II  .- Juzgado Segundo de Ejecución."
                                                    + "</br>III .- Unidad de Gestión";
                        }
                        else
                        {
                            if (estado==false)
                            {
                                Verificado.Estatus = false;
                                Verificado.Mensaje = "Verificar código, deben ser caracteres numéricos"
                            }
                            else
                            {
                                Verificado.Estatus = estado;
                                Verificado.Mensaje = ""
                            }
                        }
                    }
                    
                    break;
                case 14:
                    if(area==42)
                    {
                        var anio = parseInt(codigo.substr(5,4));
                        var numerico14 = codigo.substr(0,13);
                        var romano14 = codigo.substr(13,1);
                        if(anio<=2020)
                        {
                            var estadoNumerico14 = !isNaN(parseFloat(numerico14)) && isFinite(numerico14);
                            var estadoRomano14 = romano14!="I" ? false: true;
                            if(estadoNumerico14==true && estadoRomano14 ==true)
                            {
                                Verificado.Estatus = estadoNumerico14;
                                Verificado.Mensaje = ""
                            }
                            else
                            {
                                if(estadoNumerico14==false && estadoRomano14 ==true)
                                {
                                Verificado.Estatus = false;
                                Verificado.Mensaje = "Verificar código, los primeros 13 digitos deben ser caracteres numéricos"
                                }
                                if(estadoNumerico14==true && estadoRomano14 ==false)
                                {
                                Verificado.Estatus = false;
                                Verificado.Mensaje = "Verificar código, numero romano no corresponde"
                                }
                            }
                        }
                        else
                        {
                        Verificado.Estatus = false;
                        Verificado.Mensaje = "Para documentos del 2021 o superiores no requiere nomenclatura con numero romano"
                        }
                    }
                    else
                    {
                        Verificado.Estatus = false;
                        Verificado.Mensaje = "Verifique el código de barras, debe contener 13 digitos numericos"
                    }
                    break;
                case 15:
                    if(area==42)
                    {
                        var anio = parseInt(codigo.substr(5,4));
                        var numerico15 = codigo.substr(0,13);
                        var romano15 = codigo.substr(13,2);
                        if(anio<=2020)
                        {
                            var estadoNumerico15 = !isNaN(parseFloat(numerico15)) && isFinite(numerico15);
                            var estadoRomano15 = romano15!="II" ? false: true;
                            if(estadoNumerico15==true && estadoRomano15 ==true)
                            {
                                Verificado.Estatus = estadoNumerico15;
                                Verificado.Mensaje = ""
                            }
                            else
                            {
                                if(estadoNumerico15==false && estadoRomano15 ==true)
                                {
                                Verificado.Estatus = false;
                                Verificado.Mensaje = "Verificar código, los primeros 13 digitos deben ser caracteres numéricos"
                                }
                                if(estadoNumerico15==true && estadoRomano15 ==false)
                                {
                                Verificado.Estatus = false;
                                Verificado.Mensaje = "Verificar código, numero romano no corresponde"
                                }
                            }
                        }
                        else
                        {
                        Verificado.Estatus = false;
                        Verificado.Mensaje = "Para documentos del 2021 o superiores no requiere nomenclatura con numero romano"
                        }
                    }
                    else
                    {
                        Verificado.Estatus = false;
                        Verificado.Mensaje = "Verifique el código de barras, debe contener 13 digitos numericos"
                    }
                    break;
                case 16:
                    if(area==42)
                    {
                        var anio = parseInt(codigo.substr(5,4));
                        var numerico16 = codigo.substr(0,13);
                        var romano16 = codigo.substr(13,3);
                        if(anio<=2020)
                        {
                            var estadoNumerico16 = !isNaN(parseFloat(numerico16)) && isFinite(numerico16);
                            var estadoRomano16 = romano16!="III" ? false: true;
                            if(estadoNumerico16==true && estadoRomano16 ==true)
                            {
                                Verificado.Estatus = estadoNumerico16;
                                Verificado.Mensaje = ""
                            }
                            else
                            {
                                if(estadoNumerico16==false && estadoRomano16 ==true)
                                {
                                Verificado.Estatus = false;
                                Verificado.Mensaje = "Verificar código, los primeros 13 digitos deben ser numericos"
                                }
                                if(estadoNumerico16==true && estadoRomano16 ==false)
                                {
                                Verificado.Estatus = false;
                                Verificado.Mensaje = "Verificar código, numero romano no corresponde"
                                }
                            }
                        }
                        else
                        {
                        Verificado.Estatus = false;
                        Verificado.Mensaje = "Para documentos del 2021 o superiores no requiere nomenclatura con numero romano"
                        }
                    }
                    else
                    {
                        Verificado.Estatus = false;
                        Verificado.Mensaje = "Verifique el código de barras, debe contener 13 digitos numericos"
                    }
                    break;
                default:
                    Verificado.Estatus = false;
                    if(codigo.length<13)
                    {
                        Verificado.Mensaje = "Verificar código de barras, debe completar los 13 digitos numericos y en su caso numero romano"
                    };
                    if(codigo.length>16)
                    {
                        Verificado.Mensaje = "Verificar código de barras, sobrepasa los 16 digitos"
                    }
                    
                    break;  
                }
            }
            if(this.Usuario.Area.AreaId!=95 && this.Usuario.Area.AreaId!=21) // las demas áreas a excepcion del archivo y juzgado de ejecucion de penas.
            {
                var area = parseInt(codigo.substr(0,2));
                if(this.Usuario.Area.AreaArchivoId==area)
                {
                    switch(codigo.length)
                    {
                        case 13:
                            var estado = !isNaN(parseFloat(codigo)) && isFinite(codigo);
                            if (estado==false)
                            {
                            Verificado.Estatus = estado;
                            Verificado.Mensaje = "Verificar código, deben ser caracteres numéricos"
                            }
                            else
                            {
                            Verificado.Estatus = estado;
                            Verificado.Mensaje = ""
                            }
                            break;
                        default:
                            Verificado.Estatus = false;
                            if(codigo.length<13)
                            {
                                Verificado.Mensaje = "Verificar código de barras, debe completar los 13 digitos numericos"
                            };
                            if(codigo.length>13)
                            {
                                Verificado.Mensaje = "Verificar código de barras, sobrepasa los 13 digitos numericos"
                            }
                            
                            break;  
                    }
                }
                else
                {
                    Verificado.Estatus = false;
                    Verificado.Mensaje = "El área del documento a consulta no corresponde a : " + this.Usuario.Area.Nombre
                }
            }
            if(this.Usuario.Area.AreaId==95) // Ejecucion de penas y medidas de seguridad
            {   
                var area = parseInt(codigo.substr(0,2));
                switch(codigo.length)
                {
                case 13:
                    var estado = !isNaN(parseFloat(codigo)) && isFinite(codigo);
                    var anio = parseInt(codigo.substr(5,4));
                    if(area==42)
                    {
                        if(anio<=2020)
                        {
                        Verificado.Estatus = false;
                        Verificado.Mensaje = "Verificar código de barras, para documento del 2020 o inferiores se requiere complementar con numero romano correspondiente al área a consultar"
                                                + "</br>I   .- Juzgado Primero de Ejecución."
                                                + "</br>II  .- Juzgado Segundo de Ejecución."
                                                + "</br>III .- Unidad de Gestión";
                        }
                        else
                        {
                            if (estado==false)
                            {
                                Verificado.Estatus = false;
                                Verificado.Mensaje = "Verificar código de barras, debe ser numerico"
                            }
                            else
                            {
                                Verificado.Estatus = estado;
                                Verificado.Mensaje = ""
                            }
                        }
                    }
                    else
                    {
                        Verificado.Estatus = false;
                        Verificado.Mensaje = "El área del documento a consulta no corresponde"
                    }
                    break;
                case 14:
                    var anio = parseInt(codigo.substr(5,4));
                    var numerico14 = codigo.substr(0,13);
                    var romano14 = codigo.substr(13,1);
                    if(anio<=2020)
                    {
                    var estadoNumerico14 = !isNaN(parseFloat(numerico14)) && isFinite(numerico14);
                    var estadoRomano14 = romano14!="I" ? false: true;
                    if(estadoNumerico14==true && estadoRomano14 ==true)
                    {
                        Verificado.Estatus = estadoNumerico14;
                        Verificado.Mensaje = ""
                    }
                    else
                    {
                        if(estadoNumerico14==false && estadoRomano14 ==true)
                        {
                        Verificado.Estatus = false;
                        Verificado.Mensaje = "Verificar código, los primeros 13 digitos deben ser caracteres numéricos"
                        }
                        if(estadoNumerico14==true && estadoRomano14 ==false)
                        {
                        Verificado.Estatus = false;
                        Verificado.Mensaje = "Verificar código, numero romano no corresponde a I, II o III"
                        }
                    }
                    }
                    else
                    {
                    Verificado.Estatus = false;
                    Verificado.Mensaje = "Para documentos del 2021 o superiores no requiere numero romano"
                    }
                    break;
                case 15:
                    var anio = parseInt(codigo.substr(5,4));
                    var numerico15 = codigo.substr(0,13);
                    var romano15 = codigo.substr(13,2);
                    if(anio<=2020)
                    {
                    var estadoNumerico15 = !isNaN(parseFloat(numerico15)) && isFinite(numerico15);
                    var estadoRomano15 = romano15!="II" ? false: true;
                    if(estadoNumerico15==true && estadoRomano15 ==true)
                    {
                        Verificado.Estatus = estadoNumerico15;
                        Verificado.Mensaje = ""
                    }
                    else
                    {
                        if(estadoNumerico15==false && estadoRomano15 ==true)
                        {
                        Verificado.Estatus = false;
                        Verificado.Mensaje = "Verificar código, los primeros 13 digitos deben ser caracteres numéricos"
                        }
                        if(estadoNumerico15==true && estadoRomano15 ==false)
                        {
                        Verificado.Estatus = false;
                        Verificado.Mensaje = "Verificar código, numero romano no corresponde a I, II o III"
                        }
                    }
                    }
                    else
                    {
                    Verificado.Estatus = false;
                    Verificado.Mensaje = "Para documentos del 2021 o superiores no requiere numero romano"
                    }
                    break;
                case 16:
                    var anio = parseInt(codigo.substr(5,4));
                    var numerico16 = codigo.substr(0,13);
                    var romano16 = codigo.substr(13,3);
                    if(anio<=2020)
                    {
                    var estadoNumerico16 = !isNaN(parseFloat(numerico16)) && isFinite(numerico16);
                    var estadoRomano16 = romano16!="III" ? false: true;
                    if(estadoNumerico16==true && estadoRomano16 ==true)
                    {
                        Verificado.Estatus = estadoNumerico16;
                        Verificado.Mensaje = ""
                    }
                    else
                    {
                        if(estadoNumerico16==false && estadoRomano16 ==true)
                        {
                        Verificado.Estatus = false;
                        Verificado.Mensaje = "Verificar código, los primeros 13 digitos deben ser caracteres numéricos"
                        }
                        if(estadoNumerico16==true && estadoRomano16 ==false)
                        {
                        Verificado.Estatus = false;
                        Verificado.Mensaje = "Verificar código, numero romano no corresponde a I, II o III"
                        }
                    }
                    }
                    else
                    {
                    Verificado.Estatus = false;
                    Verificado.Mensaje = "Para documentos del 2021 o superiores no requiere numero romano"
                    }
                    break;
                default:
                    Verificado.Estatus = false;
                    if(codigo.length<13)
                    {
                        Verificado.Mensaje = "Verificar código de barras, debe completar los 13 digitos numericos y en su caso numero romano"
                    };
                    if(codigo.length>16)
                    {
                        Verificado.Mensaje = "Verificar código de barras, sobrepasa los 16 digitos"
                    }
                    
                    break;  
                }
            }
            return Verificado;
        },
        ObtenerAnio(event){ //Agregado para los documento de medidas de seguridad y ejecucion
            var longitud = event.target.value.length;
            if((this.Usuario.Area.AreaId ==95 || this.Usuario.Area.AreaId ==21) && longitud==9)
            {
                this.AnioEjecucion = parseInt(event.target.value.substr(5));
                console.log(this.AnioEjecucion)
            }
        }
    },
    mounted(){
        this.Usuario = this.$store.state.Login_Usuario;
        if(this.Usuario.Area.AreaId !=21)
        {
        this.BusquedaForm.parametros_Area.areaId = this.Usuario.Area.AreaId;
        this.BusquedaForm.parametros_TipoDocumento.areaId = this.Usuario.Area.AreaId;
        
        }
        else
        {
            this.BusquedaForm.parametros_Area.areaId = -1;
            this.BusquedaForm.parametros_TipoDocumento.areaId = -1;
        }
            
        if (this.barCode != "" && this.barCode!= undefined)
        {
            this.BusquedaForm.CodigoBarras = this.barCode;
            this.CargaDocumento();
        }
        
    },
    watch: {
        IncidenteCode() {
            if(this.actualiza == true && this.IncidenteCode!="")
            {
                this.BusquedaForm.CodigoBarras = this.IncidenteCode;
                this.CargaDocumento();
            }
        },
        actualiza()
        {
            if(this.actualiza==true && this.barCode!="")
            {
                this.BusquedaForm.CodigoBarras = this.barCode;
                this.CargaDocumento();
            }
        }
    }
}
</script>
<style scoped>
    input[type="text"]:read-only {
            background: #f3f3f3;
    }

    input[type="text"]:read-only:focus {
            color: #fff;
        }
    .label-black {
    color: black;
    }
    .btn-custom {
        background-color: #004746;
        color: white;
    }
</style>


// WEBPACK FOOTER //
// src/components/ArchivoJudicial/Comun/ConsultaDocumento.vue